import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'qpointSafeHtml',
  standalone: true
})
export class QPointSafeHtmlPipe implements PipeTransform {
  private sanitizer: DomSanitizer = inject(DomSanitizer);

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
